import {
    /** FETCH APPLICATION  */
    FETCH_GETOTP_FULFILLED,
    FETCH_GETOTP_REJECTED,
    FETCH_GETOTP_PENDING,
    RESET_GETOTP,
} from "../../actions/agreement/getOtp";
const initialState = {
    done: false,
    error: false,
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_GETOTP_PENDING:
            return {
                done: false,
                error: false,
                spinner: true
            };
        case FETCH_GETOTP_FULFILLED:
            return {
                ...state,
                getOtp: action.payload,
                done: true,
                error: false,
                spinner: false
            };
        case FETCH_GETOTP_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case RESET_GETOTP:
            return {
                initialState,
                done: false,
                error: false,
                spinner: false
            };
        default:
            return state;
    }
};